import { render, staticRenderFns } from "./consulta.vue?vue&type=template&id=52dd2c60"
import script from "./consulta.vue?vue&type=script&lang=js"
export * from "./consulta.vue?vue&type=script&lang=js"
import style0 from "./consulta.vue?vue&type=style&index=0&id=52dd2c60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports